import { render, staticRenderFns } from "./ActivityDetial.vue?vue&type=template&id=2ef83b9c&scoped=true"
import script from "./ActivityDetial.vue?vue&type=script&lang=js"
export * from "./ActivityDetial.vue?vue&type=script&lang=js"
import style0 from "./ActivityDetial.vue?vue&type=style&index=0&id=2ef83b9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef83b9c",
  null
  
)

export default component.exports